import React from 'react';
import { TranslationFunction } from 'react-i18next';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import { ExtendedRevisionProps, Revision as RevisionComp } from '../Revision';
import { getRevisionId } from '../../helpers';
import { Revision } from '../../types';

import styles from './RevisionList.scss';

export interface RevisionListProps {
  t: TranslationFunction;
  revisions: Revision[];
  activeRevision: string;
  currentRevision: string;
  isSeparateRevisions: boolean;
  onView: ExtendedRevisionProps['onView'];
  onRestore: ExtendedRevisionProps['onRestore'];
  onStar: ExtendedRevisionProps['onStar'];
  onRename: ExtendedRevisionProps['onRename'];
}

export const RevisionList: React.FC<RevisionListProps> = ({
  t,
  revisions,
  activeRevision,
  currentRevision,
  isSeparateRevisions,
  onView,
  onRestore,
  onStar,
  onRename,
}) => {
  // @ts-ignore
  const Row = ({ index, style }) => {
    const item = revisions[index];
    return (
      <div style={style}>
        <RevisionComp
          t={t}
          key={`${item.revision}-${item.editorType}`}
          value={item}
          isActive={activeRevision === getRevisionId(item)}
          isCurrent={currentRevision === getRevisionId(item)}
          isSeparateRevisions={isSeparateRevisions}
          onView={onView}
          onRestore={onRestore}
          onStar={onStar}
          onRename={onRename}
        />
      </div>
    );
  };
  return (
    <div className={styles.revisionList}>
      <AutoSizer>
        {({ height, width }) => (
          <FixedSizeList
            itemCount={revisions.length}
            itemSize={105}
            height={height}
            width={width}
            overscanCount={5}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </div>
  );
};
